(function(){
  var hdr=document.querySelector('.colo-header');
  var sec=hdr&&hdr.closest('.shopify-section');
  if(!sec)return;
  sec.classList.add('colo-hdr-sec');
  var last=window.pageYOffset||0,busy=false;
  function sticky(){return getComputedStyle(sec).position==='sticky'}
  function menuTop(){document.documentElement.style.setProperty('--colo-menu-top',Math.max(0,Math.round(hdr.getBoundingClientRect().bottom))+'px')}
  function frame(){
    busy=false;
    var y=window.pageYOffset||0;
    var menu=document.querySelector('.colo-burger[open]');
    var typing=document.activeElement&&document.activeElement.closest&&document.activeElement.closest('.colo-search');
    if(!sticky()||menu||typing||y<90){sec.classList.remove('colo-hdr-hide')}
    else if(y>last+6){sec.classList.add('colo-hdr-hide')}
    else if(y<last-6){sec.classList.remove('colo-hdr-hide')}
    document.body.classList.toggle('colo-hdr-hidden',sec.classList.contains('colo-hdr-hide'));
    if(menu)menuTop();
    last=y;
  }
  window.addEventListener('scroll',function(){if(!busy){busy=true;requestAnimationFrame(frame)}},{passive:true});
  window.addEventListener('resize',function(){menuTop();frame()});
  document.addEventListener('toggle',function(e){if(e.target&&e.target.classList&&e.target.classList.contains('colo-burger')){sec.classList.remove('colo-hdr-hide');setTimeout(menuTop,0);setTimeout(menuTop,260)}},true);
  menuTop();
})();
